import React from "react";
import { Link } from "react-router-dom";
// import logo from "../images/logo.png";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row footer-row">
          
          {/* ===== Left Column ===== */}
          <div className="col-12 col-md-4 footer-about footer-links p-">
            <h4>Contact Us </h4>
{/* <img
  src="/images/ios.jpeg"
  alt="description"
  style={{ width: "300px", height: "150px" }}
/> */}

            {/* <img src="/images/99.jpg" alt="Pune Corporate Cars India Private Limited" className="footer-logo" /> */}
            {/* <p className="footer-text">
              Pune Corporate Cars India Private Limited is a trusted and customer-focused cab service
              provider specializing in reliable, comfortable, and affordable
              travel solutions across Mumbai, Pune, and nearby regions.
            </p> */}


<ul className="footer-contact">
  <li>
    <i className="fas fa-headset"></i>{" "}
    <strong>Reservations | Booking Helpdesk 24×7</strong>
  </li>

  <li>
    <i className="fas fa-envelope"></i>{" "}
    <a href="mailto:reservations@punecorporatecars.com">
      reservations@punecorporatecars.com
    </a>
  </li>

  <li>
    <i className="fas fa-phone"></i>{" "}
    <strong>Operation Help Desk 24×7:</strong>{" "}
    
  </li>
<li>
  <i className="fas fa-phone"></i>{" "}
  <a href="tel:919822943334">+91 9822943334</a>{" / "}
    <a href="tel:919405644855">+91 9405644855</a>
</li>
  <li>
    <i className="fas fa-briefcase"></i>{" "}
    <strong>Corporate Sales (Pan India)</strong>
  </li>

  <li>
    <i className="fas fa-envelope"></i>{" "}
    <a href="mailto:sales@punecorporatecars.com">
      sales@punecorporatecars.com
    </a>
  </li>

  <li>
    <i className="fas fa-envelope"></i>{" "}
    <a href="mailto:sanjay.nalawade@punecorporatecars.com">
      sanjay.nalawade@punecorporatecars.com
    </a>
  </li>

  <li>
    <i className="fas fa-phone"></i>{" "}
    <strong>Mob:</strong>{" "}
    <a href="tel:919822136667">+91 9822136667</a>{" / "}
    <a href="tel:917350959600">+91 7350959600</a>
  </li>
</ul>


            {/* <ul className="footer-contact">
              <li>
                <i className="fas fa-envelope"></i>{" "}
                <a href="mailto:sanjay.nalawade@punecorporatecars.com">
                  sanjay.nalawade@punecorporatecars.com
                </a>
              </li>
              <li>
                <i className="fas fa-phone"></i>{" "}
                <a href="tel:919822136667">+91 9822136667</a>
              </li>
              <li>
                <i className="fas fa-phone"></i>{" "}
                <a href="tel:917350959600">+91 7350959600</a>
              </li>
               <li>
                <i className="fas fa-phone "></i>{" "}
                <a href="tel:917507705135">+91 7507705135</a>
              </li>
            </ul> */}

                  <div className="social-icons d-flex pb-2">
        <a
          href="https://www.facebook.com/punecorporatecars/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-facebook-f text-white"></i>
        </a>

        <a
          href="https://www.instagram.com/punecorporatecars/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-instagram text-white"></i>
        </a>

        <a
          href="https://www.linkedin.com/in/sanjay-nalawade/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-linkedin-in text-white"></i>
        </a>

        <a
          href="https://x.com/sanjaynalawad"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-x-twitter text-white"></i>
        </a>

        <a
          href="https://in.pinterest.com/punecorporatecars/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-pinterest-p text-white"></i>
        </a>
      </div>

{/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3117.527604736206!2d73.9374114!3d18.5558542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c3d8c5eaaaab%3A0x2f83e51b1eacecfd!2sPUNE%20CORPORATE%20CARS%20INDIA%20PRIVATE%20LIMITED!5e1!3m2!1sen!2sin!4v1764057042268!5m2!1sen!2sin" width="300" height="130"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}

<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2880.806902763053!2d73.948329!3d18.5748324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c3a24a05c2e9%3A0xe0adac94b3791e47!2sACC%20CONCRETE%20KHARADI!5e1!3m2!1sen!2sin!4v1785574582007!5m2!1sen!2sin" width="300" height="130"   allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>

          </div>

          {/* ===== Middle Column ===== */}
          <div className="col-12 col-md-2 footer-links">
            <h4>Quick Links </h4>


            <ul className="footer-service-list">
{/* <li><Link to="/"> Home</Link></li> */}
<li><Link to="/about"> About Us</Link></li>
<li><Link to="/term-condition"> Terms & Conditions</Link></li>
<li><Link to="/privacy-policy"> Privacy Policy</Link></li>
<li><Link to="/gallery"> Gallery</Link></li>
<li><Link to="/Career"> Career</Link></li>
<li><Link to="/corporate-cab-service-in-pune" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate cab service in pune</Link></li>
<li><Link to="/Monthly-Cab-Services-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Monthly Cab Services in Pune</Link></li>
<li><Link to="/Corporate-Car-Rental-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Car Rental in Pune</Link></li>
<li><Link to="/Corporate-Car-Rentals-Services-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Car Rentals Services in Pune</Link></li>
<li><Link to="/Corporate-cab-services-for-Pune-Outstation" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate cab services for Pune Outstation</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Kharadi" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Kharadi</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Hadapsar" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Hadapsar</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Viman-Nagar" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Viman Nagar</Link></li>
<li><Link to="/Monthly-Pick-and-Drop-Service-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Monthly Pick and Drop Service Pune</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Hinjewadi" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Hinjewadi</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Talegaon-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Talegaon MIDC</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Chakan-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Chakan MIDC</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Talawade-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Talawade MIDC</Link></li>
<li><Link to="/Cab-Service-for-IT-Company-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Cab Service for IT Company in Pune</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Bhosari-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Bhosari MIDC</Link></li>
<li><Link to="/Office-Pickup-and-Drop-Service-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Office Pickup and Drop Service in Pune</Link></li>
<li><Link to="/Corporate-Cabs-Services-in-Sanaswadi" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cabs Services in Sanaswadi</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Ranjangaon-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Ranjangaon MIDC</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Karegaon-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Karegaon MIDC</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Shirwal-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Shirwal MIDC</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Shikrapur-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Shikrapur MIDC</Link></li>
<li><Link to="/Cab-Service-in-Jejuri-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Cab Service in Jejuri MIDC</Link></li>
<li><Link to="/Best-Cab-Service-for-Corporate-Employees-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Best Cab Service for Corporate Employees Pune</Link></li>
<li><Link to="/Corporate-Travel-Companies-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Travel Companies in Pune</Link></li>
<li><Link to="/Innova-Crysta-Hire-for-Corporate-Events-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Innova Crysta Hire for Corporate Events in Pune</Link></li>
<li><Link to="/Pune-Airport-Corporate-Cab-Service" className="d-none"><i className="fas fa-car footer-icon"></i> Pune Airport Corporate Cab Service</Link></li>
<li><Link to="/Cab-Service-in-Kurkumbh-Daund-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Cab Service in Kurkumbh Daund MIDC</Link></li>
<li><Link to="/Cab-Service-in-Supa-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Cab Service in Supa Midc</Link></li>

<li><Link to="/Corporate-cab-Services-in-Khed-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate cab Services in Khed MIDC</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Magarpatta-City" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Magarpatta City</Link></li>
<li><Link to="/Cab-Service-in-Markal-MIDC-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Cab Service in Markal MIDC Pune</Link></li>
<li><Link to="/Corporate-Mobility-Solutions-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Mobility Solutions in Pune</Link></li>
<li><Link to="/Monthly-Transportation-Services-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Monthly Transportation Services in Pune</Link></li>
<li><Link to="/Top-Car-Rental-Company-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Top Car Rental Company in Pune</Link></li>
<li><Link to="/Corporate-Car-Rental-Service-Provider-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Car Rental Service Provider in Pune</Link></li>
<li><Link to="/Luxury-Car-Rentals-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Luxury Car Rentals in Pune</Link></li>


<li><Link to="/Sedan-Cab-Service-for-Corporate-Employees-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Sedan Cab Service for Corporate Employees Pune</Link></li>
<li><Link to="/Ertiga-Hire-for-Corporate-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Ertiga Hire for Corporate in Pune</Link></li>
<li><Link to="/Kia-Carens-On-Rent-for-Corporate-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Kia Carens On Rent for Corporate in Pune</Link></li>
<li><Link to="/Swift-Dzire-on-Rent-in-Pune-for-Corporate" className="d-none"><i className="fas fa-car footer-icon"></i> Swift Dzire on Rent in Pune for Corporate</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Mumbai" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Mumbai</Link></li>        
<li><Link to="/Corporate-cab-services-in-Thane" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate cab services in Thane</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Bandra-Kurla-Complex" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Bandra Kurla Complex</Link></li>

{/* <li><Link to="/about">About Us</Link></li>
<li><Link to="/term-condition">Terms & Conditions</Link></li>
<li><Link to="/privacy-policy">Privacy Policy</Link></li>
<li><Link to="/our-fleet">Our Fleets</Link></li>
<li><Link to="/services">services</Link></li>
<li><Link to="/gallery">gallery</Link></li>
<li><Link to="/contact-us">Contact Us</Link></li> */}
 
 </ul>
          </div>

          {/* ===== Right Column ===== */}
          <div className=" col-12 col-md-2 footer-links">
             <h4>Rides</h4>
            <ul className="footer-service-list">
<li><Link to="/sedan"> Sedan Cars</Link></li>
<li><Link to="/muv"> MUV Cars</Link></li>
<li><Link to="/premium"> Premium Cars</Link></li>
<li><Link to="/luxury"> Luxury Cars</Link></li>
<li><Link to="/buses"> Buses</Link></li>



<li><Link to="/Corporate-cab-services-in-Navi-Mumbai-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate cab services in Navi Mumbai MIDC</Link></li>
<li><Link to="/Corporate-cab-services-in-Bhiwandi-and-Taloja-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate cab services in Bhiwandi and Taloja MIDC</Link></li>
<li><Link to="/Cab-Service-in-Marol-MIDC-Andheri" className="d-none"><i className="fas fa-car footer-icon"></i> Cab Service in Marol Midc Andheri</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Powai-MIDC-Mumbai" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Powai Midc Mumbai</Link></li>
<li><Link to="/Mumbai-Airport-Corporate-Cab-Services" className="d-none"><i className="fas fa-car footer-icon"></i> Mumbai Airport Corporate Cab Services</Link></li>
<li><Link to="/Corporate-Cab-Services-Panvel-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services Panvel MIDC</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Airoli-Mumbai" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Airoli Mumbai</Link></li>
<li><Link to="/Corporate-Car-Rental-in-Turbhe-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Car Rental in Turbhe MIDC</Link></li>
<li><Link to="/Cab-Service-in-Mahape-Navi-Mumbai" className="d-none"><i className="fas fa-car footer-icon"></i> Cab Service in Mahape Navi Mumbai</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Palghar-MIDC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Palghar midc</Link></li>
<li><Link to="/Corporate-Cab-Services-for-Corporate-Events-in-Mumbai" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services for Corporate Events in Mumbai</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Navi-Mumbai-Airport" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Navi Mumbai Airport</Link></li>

<li><Link to="/Corporate-Cab-Services-in-Delhi" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Delhi</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Gurgaon" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Gurgaon</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Delhi-NCR" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Delhi NCR</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Okhla-Delhi" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Okhla Delhi</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Delhi-for-Industrial" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Delhi for Industrial</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Bangalore" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Bangalore</Link></li>
<li><Link to="/Corporate-Cabs-Taxi-Bangalore" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cabs Taxi Bangalore</Link></li>
<li><Link to="/Cab-Service-in-Electronic-City-Bangalore" className="d-none"><i className="fas fa-car footer-icon"></i> Cab Service in Electronic City Bangalore</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Manyata-Tech-Park-Nagavara-Bangalore" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Manyata Tech Park (Nagavara) Bangalore</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Bagmane-Tech-Park-CV-Raman-Nagar" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Bagmane Tech Park (C.V. Raman Nagar)</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Outer-Ring-Road-ORR-Corridor" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Outer Ring Road (ORR) Corridor</Link></li>
<li><Link to="/Bangalore-International-Airport-Corporate-Cab-Service" className="d-none"><i className="fas fa-car footer-icon"></i> Bangalore International Airport Corporate Cab Service</Link></li>
<li><Link to="/Outstation-Corporate-Cab-Service-in-Bangalore" className="d-none"><i className="fas fa-car footer-icon"></i> Outstation Corporate Cab Service in Bangalore</Link></li>

<li><Link to="/Corporate-Cab-Services-in-Chennai" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Chennai</Link></li>
<li><Link to="/Corporate-Cab-Services-in-Madras" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Services in Madras</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Ambattur-Chennai" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Ambattur Chennai</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Tidel-Park-Chennai" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Tidel Park Chennai</Link></li>
<li><Link to="/Corporate-Cab-Service-in-International-Tech-Park-Chennai-ITPC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in International Tech Park Chennai (ITPC)</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Olympia-Tech-Park-Chennai" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Olympia Tech Park Chennai</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Ramanujan-IT-City" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Ramanujan IT City</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Ambattur-Ambit-IT-Park" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Ambattur Ambit IT Park</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Oragadam-Chennai" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Oragadam Chennai</Link></li>

<li><Link to="/Corporate-Cab-Service-in-Hyderabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate cab service in Hyderabad</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Hitech-City-Hyderabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Hitech City Hyderabad</Link></li>



   </ul>
          </div>
        















         <div className=" col-12 col-md-4 footer-links">
             <h4>Certified By</h4>
            <ul className="footer-service-list">

{/*               
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3117.527604736206!2d73.9374114!3d18.5558542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c3d8c5eaaaab%3A0x2f83e51b1eacecfd!2sPUNE%20CORPORATE%20CARS%20INDIA%20PRIVATE%20LIMITED!5e1!3m2!1sen!2sin!4v1764057042268!5m2!1sen!2sin" width="300" height="200"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}

<img
  src="/images/ios.jpeg"
  alt="description"
  style={{ width: "100%", height: "100%" }}
/>


<li><Link to="/Corporate-Cab-Service-in-Cyberabad-Hyderabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Cyberabad Hyderabad</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Madhapur-Hyderabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Madhapur Hyderabad</Link></li>
<li><Link to="/Corporate-Cab-Service-Kondapur-Hyderabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service Kondapur Hyderabad</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Patancheru-Hyderabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Patancheru Hyderabad</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Genome-Valley-Hyderabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Genome Valley Hyderabad</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Balanagar-Hyderabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Balanagar Hyderabad</Link></li>

<li><Link to="/Corporate-Car-Rental-Services-in-Ahmedabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Car Rental Services in Ahmedabad</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Million-Minds-Tech-City-Ahmedabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Million Minds Tech City Ahmedabad</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Titanium-Business-Park-Ahmedabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Titanium Business Park Ahmedabad</Link></li>

<li><Link to="/Corporate-Cab-Service-in-Sanand-GIDC-Ahmedabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Sanand GIDC Ahmedabad</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Narol-GIDC-Ahmedabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Narol GIDC Ahmedabad</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Kathwada-GIDC-Ahmedabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Kathwada GIDC Ahmedabad</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Odhav-GIDC-Ahmedabad" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Odhav GIDC Ahmedabad</Link></li>

<li><Link to="/Corporate-Car-Rental-Services-in-Kolkata" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Car Rental Services in Kolkata</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Howrah" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Howrah</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Durgapur-Industrial-Area" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Durgapur Industrial Area</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Haldia-Industrial-Park" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Haldia Industrial Park</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Uluberia-Industrial-Park" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Uluberia Industrial Park</Link></li>

<li><Link to="/Corporate-Cab-Service-in-Jaipur" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Jaipur</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Vishwakarma-Industrial-Area-VKI" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Vishwakarma Industrial Area (VKI)</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Sitapura-Industrial-Area" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Sitapura Industrial Area</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Malviya-Industrial-Area-MIA" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Malviya Industrial Area (MIA)</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Mahindra-World-City-MWC" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate cab service in Mahindra World City (MWC)</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Bagru-Industrial-Area" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate cab service in Bagru Industrial Area</Link></li>
<li><Link to="/Corporate-Cab-Service-in-Rajasthan" className="d-none"><i className="fas fa-car footer-icon"></i> Corporate Cab Service in Rajasthan</Link></li>
<li><Link to="/Pan-India-Corporate-Cab-Service" className="d-none"><i className="fas fa-car footer-icon"></i> Pan India Corporate Cab Service</Link></li>

<li><Link to="/Employee-Transport-Services-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Employee Transport Services in Pune</Link></li>
<li><Link to="/Hotel-Travel-Desk-Cab-Service-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Hotel Travel Desk Cab Service in Pune</Link></li>
<li><Link to="/Conference-and-Delegation-Car-Rental-Services-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Conference & Delegation Car Rental Services in Pune</Link></li>
<li><Link to="/Event-Transportation-Services-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Event Transportation Services in Pune</Link></li>
<li><Link to="/Wedding-Car-Rental-Services-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Wedding Car Rental services In Pune</Link></li>
<li><Link to="/Travels-Partners-Program-in-Pune" className="d-none"><i className="fas fa-car footer-icon"></i> Travels Partners Program in Pune</Link></li>


   </ul>
          </div>
     




</div>








        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="text-white">
            © {new Date().getFullYear()} <strong>Pune Corporate Cars India Private Limited</strong> | Developed by{" "}
            <a href="https://www.dexterintelligence.com/" target="_blank" rel="noopener noreferrer">
              Dexter Intelligence
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;